import React, { useState, useEffect } from "react";
import { useFlags } from "launchdarkly-react-client-sdk";
import { Grid } from "@mui/material";
import { useParams, useLocation } from "react-router-dom";

import PageTitle from "components/Widgets/PageTitle";
import PayrollDetails from "components/Screens/PayrollHistoryDetail/PayrollDetails/PayrollDetails";
import PayrollDetailsOld from "components/Screens/PayrollHistoryDetail/PayrollDetails";
import TopHeader from "components/common/TopHeader";
import useBreadcrumbs from "hooks/useBreadcrumbs";

import NavigationRoutes from "constants/NavigationRoutes";

function PayrollHistoryDetail() {
  const { platformHeader } = useFlags();
  const { id } = useParams();
  const location = useLocation();
  const { setLabel, resetLabels } = useBreadcrumbs();
  const { customizedInvoicing } = useFlags();

  const { paymentType } = location.state || {};

  const [payrollMonth, setPayrollMonth] = useState("");

  const getPayrollMonth = (month) => {
    setPayrollMonth(month);

    if (id && month) {
      setLabel(location.pathname, `Payroll for ${month}`);
    }
  };

  useEffect(() => {
    if (id) {
      setLabel(location.pathname, payrollMonth ? `Payroll for ${payrollMonth}` : "Payroll Detail");
    }
  }, [id, location.pathname, payrollMonth]);

  useEffect(() => {
    return () => resetLabels();
  }, []);

  return (
    <Grid sx={{ background: "#FBFAFF", minHeight: "calc(100vh - 51px)" }}>
      {platformHeader ? (
        <div className="pb-20p">
          <TopHeader
            title={`${payrollMonth} - ${paymentType} Payment`}
            linkName={`Payroll / Payroll for ${payrollMonth || "-"}`}
            backIcon={NavigationRoutes.payrollHistory}
          />
        </div>
      ) : (
        <Grid
          container
          rowSpacing={3}
          sx={{
            marginTop: "5px",
          }}
        >
          <PageTitle
            background="#FBFAFF"
            page={{
              title: `Payroll for ${payrollMonth}`,
              linkName: "Payroll",
              link: "back",
              child: payrollMonth ? `Payroll for ${payrollMonth}` : "details",
            }}
          />
        </Grid>
      )}

      <Grid container>
        {customizedInvoicing ? (
          <PayrollDetails getPayrollMonth={getPayrollMonth} />
        ) : (
          <PayrollDetailsOld getPayrollMonth={getPayrollMonth} />
        )}
      </Grid>
    </Grid>
  );
}

export default PayrollHistoryDetail;
